import { connect } from 'react-redux';
import { fetchStatsColumns, fetchStats } from '../../actions/index';
import Stats from '../../components/Stats/Stats';

const mapStateToProps = state => {
    return {
        statsColumns: state.statsColumns,
        stats: state.stats,
        rowFilter: state.rowFilters,
        statsLoading: state.statsLoading
    }
};

export default connect(
    mapStateToProps,
    { fetchStatsColumns, fetchStats }
)(Stats);


// WEBPACK FOOTER //
// ./src/containers/Stats/StatsContainer.js